import React from 'react';

import { 
	func, 
	number,
} from 'prop-types';

export default class Container extends React.Component {
	static propTypes = {
		time : number,
    	onSubmit : func.isRequired,
    	render : func.isRequired,
	}
	constructor(props){
		super(props);
		const {time} = props;
    	let min = 0;
    	let sec = 0;
    	if(time){
    		min = Math.floor(time/60);
    		sec = time%60;
    	}
		this.state = {
			min,
			sec,
			...this.state
		};
	}
    onEnableInputMode = (e) =>{
    	this.setState({inputMode:true});
    	e.preventDefault(); // for disable onChange event.
    };

	onSubmit = ({minute,sec}) =>{
		this.setState({inputMode:false});
		this.props.onSubmit(Number(minute) * 60 + Number(sec));
	}

	onCancelTimer = () =>{
		this.setState({inputMode:false});
	}
  
	render(){
    	const {render,onSubmit,...other} = this.props;
    	return render({
			min : this.state.min,
			sec : this.state.sec,
    		onChangeMinute : (e)=>{
				this.setState({min:e.target.value});
			},
			onChangeSec : (e)=>{
				this.setState({sec:e.target.value});
			},
			onSubmit : ()=>{
				const min = Number(this.state.min);
				const sec = Number(this.state.sec);
				onSubmit && onSubmit(min*60+sec);
			},
    	},other);
	}
}